import { SocialLinks } from './SocialLinks.tsx';
import { UtilityNav } from './UtilityNav.tsx';
import { Navigation } from './Navigation.tsx';
import { resolveImagePath } from '@/utils/imageMap.ts';

export interface HeaderProps {
  className?: string;
}

export function Header({ className = "" }: HeaderProps) {
  return (
    <header className={`bg-white shadow-sm ${className}`}>
      {/* Top bar with social links and utility navigation */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-2">
            <SocialLinks />
            <UtilityNav />
          </div>
        </div>
      </div>

      {/* Main header with logo and navigation */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a 
              href="/"
              className="flex items-center"
            >
              <img
                src={resolveImagePath('/wp-content/uploads/logo-sticky.png')}
                alt="Northampton Airport Logo"
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Main Navigation */}
          <Navigation className="hidden lg:block" />

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button 
              type="button"
              className="p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile navigation menu - hidden by default */}
      <div className="lg:hidden hidden">
        <div className="px-4 py-2 space-y-1 bg-gray-50 border-t border-gray-200">
          {/* Mobile menu items would go here */}
          <a href="/flight-training" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-md">
            Flight Training
          </a>
          <a href="/go-flying" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-md">
            Go Flying  
          </a>
          <a href="/maintenance" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-md">
            Maintenance
          </a>
          <a href="/about" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-md">
            About
          </a>
          <a href="/community-outreach/community-outreach-2" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-md">
            Community Outreach
          </a>
          <a href="http://www.northamptonairportmerchandise.com/shop" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-md" target="_blank" rel="noopener noreferrer">
            Shop
          </a>
        </div>
      </div>
    </header>
  );
}